import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { first } from 'rxjs/operators';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';

@Component({
  selector: 'app-workshop-lgc',
  templateUrl: './workshop-lgc.component.html',
  styleUrls: ['./workshop-lgc.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopLgcComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;

  /** WORKSHOP MNG */
  workshopLgcList: any[];
  workshopLgcSelected: any;

  coordinationSelected: any;
  periodSelected: any;
  yearSelected: any;
  yearActual: number;

  /** STATUS MODAL */
  displayModalStatus: boolean;
  statusList: ValuesVO[]
  statusSelected: string;
  dateSelected: string;
  commentsSelected: string;


  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lstCols: { field: string; header: any; }[];



  /**
   * This is a constructor function that initializes various services and checks for data passed through
   * navigation, redirecting if none is found.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success or error messages.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service provided
   * by the PrimeNG library that allows for displaying confirmation dialogs to the user. It can be used
   * to confirm actions before they are executed, such as deleting a record or submitting a form.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It is used to navigate to different
   * routes and pass data between them. In this constructor, the router is injected as a dependency and
   * is used to get the current navigation and extract any state data
   * @param {AuthenticationService} authenticationService - This parameter is likely a service that
   * handles user authentication and authorization. It may contain methods for logging in, logging out,
   * and checking user roles and permissions.
   * @param {TovpilUtilsService} tovpilUtils - tovpilUtils is a service that provides utility functions
   * for the TOVPIL application. It is likely used to perform common tasks such as formatting data,
   * validating input, or handling errors.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService) {

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  /**
   * The ngOnInit function initializes component properties and retrieves security information.
   */
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }


  /**
   * This function retrieves security information and loads participants.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
        });
    } else {
      this.getTranslatedLabels();
    }
  }



  /**
   * This function loads participants for a specific workshop using an API service.
   */
  loadWorkShopMng() {

    let params = {
      storeId: this.storeId ? this.storeId : this.coordinationSelected,
      year: this.yearSelected,
      period: this.periodSelected
    }

    this.apiService.listWorkShopsByStoreId(params).then(
      data => {
        this.workshopLgcList = (data);
      }).catch(error => {
        console.error(error);
      });

  }


  /**
   * The function retrieves translations for a list of labels and updates their values in the component.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_church_name, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.getLstCols();
      });
    this.loadData(this.security);
  }




  exportExcel() {
    if (this.workshopLgcList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.workshopLgcList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.workshopLgcList.map((item) => ({
        "ID": item.gui ? (item.gui.guideId || 'S/N') : 'S/N',
        "TIPO": item.guiScr ? (item.guiScr.guiType || 'S/N') : 'S/N',
        "NOMBRE": item.gui ? (item.gui.name || 'S/N') : 'S/N',
        "SERVICIO": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
        "ESTATUS": item.f0 ? (item.f0.status || 'S/N') : 'S/N',
      }));


      this.filesService.tovpilExportXLSX(filteredJSON, 'listServicesLGC_');

    }
  }

  exportPdf() {
    if (this.workshopLgcList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.workshopLgcList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.workshopLgcList.map((item) => ({
        "ID": item.gui ? (item.gui.guideId || 'S/N') : 'S/N',
        "TIPO": item.guiScr ? (item.guiScr.guiType || 'S/N') : 'S/N',
        "NOMBRE": item.gui ? (item.gui.name || 'S/N') : 'S/N',
        "SERVICIO": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
        "ESTATUS": item.f0 ? (item.f0.status || 'S/N') : 'S/N',
      }));



      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listServicesLGC_');

    }
  }



  /**
 * The function "goBack" closes the current window.
 */
  goBack() {
    window.close();
  }

  loadData(dataSecurity: any) {
    if (dataSecurity != null) {
      this.coordinationSelected = this.storeId ? this.storeId : dataSecurity.storeId;
      this.yearSelected = dataSecurity.selYear;
      this.periodSelected = dataSecurity.selPeriod;
      this.yearActual = new Date().getFullYear();
    }

    this.loadWorkShopMng();
  }

  createNewWorkshopMng() {
    this.editWorkshopMng(null);

  }

  editWorkshopMng(data: any) {
    let workSel;

    if (data == null) {
      workSel = null;
    } else {
      workSel = {
        wrksId: data.f0.wrksId,
        fromTime: this.convertToTimeFormat(parseInt(data.f0.fromTime)),
        toTime: this.convertToTimeFormat(parseInt(data.f0.toTime)),
        guideId: data.f0.guideId,
        serTyp: data.f0.guideId,
        wsName: data.wst.wsName,
        status: data.f0.status,
        strDate: data.f0.strDate,
        endDate: data.f0.endDate,
        anio: data.f0.anio,
        period: data.f0.period,
        weekDay: data.f0.weekDay,
        churchId: data.chr.churchId,
        partN15s: data.f0.partN15s,
        partN2s: data.f0.partN2s,
        comment: data.f0.comment,
        mateGuideId: data.f0.mateGuideId,
        assistGuideId: data.f0.assistGuideId,
        language: data.language,
        churchAdress: data.chr
      }
    }

    let obj = {
      workshop: workSel,
      security: this.security,
      type: 'WM'
    }

    let queryParamsDetail = {}

    if (this.token && this.device) {

      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(
      ['/guide/workshopsDetail'], navigationExtras);
  }


  convertToTimeFormat(num: number): string {
    const hours = Math.floor(num / 100);
    const minutes = num % 100;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  showDialogStatus(workshopSelected: any) {
    this.statusSelected = null;
    this.commentsSelected = null;
    this.dateSelected = null;
    this.workshopLgcSelected = workshopSelected;
    this.loadStatusParticipant();
    this.displayModalStatus = true;
  }

  loadStatusParticipant() {
    // AQUI CAMBIAR ESTATUS DE FORMA DINAMICA
    let params = {
      guideId: this.workshopLgcSelected.gui.guideId,
      language: this.security.language
    }
    this.apiService.listStatusGuide(params).then(
      status => {
        this.statusList = status;
      }).catch(error => {
        console.error(error);
      });
  }

  /**
 * The function sets the values of an array of objects representing columns for a table.
 */

  getLstCols() {
    this.lstCols = [
      { field: 'gui.guideId', header: "" },
      { field: 'guiScr.guiType', header: "" },
      { field: 'gui.name', header: "" },
      { field: 'wst.wsName', header: "" },
      { field: 'f0.status', header: "" },
    ];
  }

  updateStatusWorkshopMng() {
    let params = {
      guideId: this.workshopLgcSelected.gui.guideId,
      newStatus: this.statusSelected['type'],
      quitDate: this.tovpilUtils.dateToTovpilDate(new Date(this.dateSelected)),
      comments: this.commentsSelected,
    }
    //CHECK
    this.apiService.changeStatusGuide(params).then(
      data => {
        if (data.status == 'OK') {
          this.messageService.add({
            severity: 'success', summary: this.lbl_updated_data, detail: ' ', life: 3000
          });

        } else {
          this.messageService.add({ severity: 'error', summary: 'schoolFpgChangeStatusGuide()', detail: data.errorMessage, life: 9000 });
        }
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'schoolFpgChangeStatusGuide', detail: error, life: 3000 });
      });

    this.workshopLgcSelected = null;
    this.displayModalStatus = false;
  }

}
